import React from 'react';

function MenuBar({ username, onOpenUploader, onOpenScanner, onOpenPrint, onLogout }) {  const handleLogout = () => {
    if (window.confirm('Ви впевнені, що хочете вийти?')) {
      localStorage.removeItem('username');
      onLogout();
    }
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {      // Входимо в повноекранний режим
      document.documentElement.requestFullscreen().catch(err => {
        console.log('Помилка при переході в повноекранний режим:', err);
      });
    } else {
      // Виходимо з повноекранного режиму
      document.exitFullscreen().catch(err => {
        console.log('Помилка при виході з повноекранного режиму:', err);
      });
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: window.innerWidth < 768 ? '8px 12px' : '12px 16px',
      backgroundColor: '#2196f3',
      color: '#fff',
      borderBottom: '1px solid #1976d2',
      flexShrink: 0,
      margin: 0
    }}>
      {/* Левая часть - логотип и название */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ 
          fontSize: '24px', 
          marginRight: '12px',
          display: window.innerWidth < 768 ? 'none' : 'block' // Скрываем логотип на мобильных
        }}>📦</span>
        <div style={{ 
          display: window.innerWidth < 768 ? 'none' : 'block' // Скрываем на мобильных
        }}>
          <h1 style={{ 
            margin: 0, 
            fontSize: '18px', 
            fontWeight: '600' 
          }}>
            Position Scanning System
          </h1>
          <div style={{ 
            fontSize: '12px', 
            opacity: 0.8,
            marginTop: '2px'
          }}>
            Warehouse Document Management | Управління складськими документами
          </div>
        </div>
      </div>

      {/* Центральная часть - кнопки действий */}
      <div style={{ 
        display: 'flex', 
        gap: '8px',
        alignItems: 'center'
      }}>
        <button
          onClick={onOpenUploader}
          style={{
            padding: window.innerWidth < 768 ? '12px' : '8px 12px',
            fontSize: window.innerWidth < 768 ? '18px' : '12px',
            background: 'rgba(255,255,255,0.1)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            minWidth: window.innerWidth < 768 ? '44px' : 'auto',
            height: window.innerWidth < 768 ? '44px' : 'auto',
            justifyContent: 'center'
          }}          title="Завантажити файли / Upload Files / Завантажити файли"
        >
          📁 {window.innerWidth >= 768 && 'Файли'}
        </button>

        <button
          onClick={onOpenScanner}
          style={{
            padding: window.innerWidth < 768 ? '12px' : '8px 12px',
            fontSize: window.innerWidth < 768 ? '18px' : '12px',
            background: 'rgba(255,255,255,0.1)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            minWidth: window.innerWidth < 768 ? '44px' : 'auto',
            height: window.innerWidth < 768 ? '44px' : 'auto',
            justifyContent: 'center'
          }}          title="Відкрити сканер / Open Scanner / Відкрити сканер"
        >
          📷 {window.innerWidth >= 768 && 'Сканер'}
        </button>

        <button
          onClick={() => onOpenPrint([])}
          style={{
            padding: window.innerWidth < 768 ? '12px' : '8px 12px',
            fontSize: window.innerWidth < 768 ? '18px' : '12px',
            background: 'rgba(255,255,255,0.1)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            minWidth: window.innerWidth < 768 ? '44px' : 'auto',
            height: window.innerWidth < 768 ? '44px' : 'auto',
            justifyContent: 'center'
          }}          title="Друк / Print / Друк"
        >
          🖨️ {window.innerWidth >= 768 && 'Друк'}
        </button>

        <button
          onClick={toggleFullscreen}
          style={{
            padding: window.innerWidth < 768 ? '12px' : '8px 12px',
            fontSize: window.innerWidth < 768 ? '18px' : '12px',
            background: 'rgba(255,255,255,0.1)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            minWidth: window.innerWidth < 768 ? '44px' : 'auto',
            height: window.innerWidth < 768 ? '44px' : 'auto',
            justifyContent: 'center'
          }}
          title="Повноекранний режим (F11) / Fullscreen (F11) / Повноекранний режим (F11)"
        >
          ⛶ {window.innerWidth >= 768 && 'F11'}
        </button>
      </div>

      {/* Правая часть - информация о пользователе */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{ 
          textAlign: 'right',
          fontSize: '14px'
        }}>
          <div style={{ fontWeight: '500' }}>
            👤 {username}
          </div>
          <div style={{ 
            fontSize: '11px', 
            opacity: 0.8,
            marginTop: '2px'
          }}>
            {new Date().toLocaleDateString('uk-UA')}
          </div>
        </div>

        <button
          onClick={handleLogout}
          style={{
            padding: window.innerWidth < 768 ? '12px' : '6px 10px',
            fontSize: window.innerWidth < 768 ? '18px' : '12px',
            background: 'rgba(255,255,255,0.1)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '4px',
            cursor: 'pointer',
            minWidth: window.innerWidth < 768 ? '44px' : 'auto',
            height: window.innerWidth < 768 ? '44px' : 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}          title="Вийти з системи / Logout / Вийти з системи"
        >
          🚪 {window.innerWidth >= 768 && 'Вихід'}
        </button>
      </div>
    </div>
  );
}

export default MenuBar;
